<div class="dialog-header">
    <h2>Clause Comparision</h2>
    <ng-icon name="heroXMark" mat-dialog-close class="cursor-pointer"></ng-icon>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
    <div class="row comparision" *ngIf="!nochange">
        <div class="col-md-6">
            <h4>Standard Language (Version 1)</h4>
            <p>
                {{ data.clauseData.oldText }}
            </p>
        </div>
        <div class="col-md-6">
            <h4>Redefined Language (Version {{ data.clauseData.version }})</h4>
            <p [innerHTML]="editedClause"></p>
            <mat-divider></mat-divider>
            <div class="comment">
                <h4>Last Audit</h4>
                <p><strong>Log:</strong> Version {{ data.clauseData.version }} created by {{ data.clauseData.updatedBy
                    }} on {{ getFormattedDate(data.clauseData.updatedDate) }}</p>
                <div *ngFor="let log of loggedClause" class="log-section">
                    <ng-container *ngIf="log.id !== 'Same'">
                        <p class="mb-0"><strong>{{ log.id }}:</strong></p>
                        <p [innerHTML]="log.value"></p>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="row comparision" *ngIf="nochange">
        <div class="col-md-12">
            <p>
                There is no change in the Clause.
            </p>
        </div>
    </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button color="primary" mat-raised-button class="outlined-btn" mat-dialog-close>Close</button>
</mat-dialog-actions>